export const ProgressBar = ({ label, step, percent }) => (
  <div className="relative border-b border-[rgba(232,184,74,0.2)] bg-[linear-gradient(180deg,#141210,#070707)]" data-testid="progress-bar">
    <div className="gutter py-4">
      <div className="flex flex-col gap-1 sm:flex-row sm:items-center sm:justify-between sm:gap-4">
        <p className="font-mono-plex gold-text text-[10.5px] font-semibold tracking-[0.05em] sm:text-[12px] sm:tracking-[0.2em]" data-testid="progress-bar-label">{label}</p>
        <p className="font-mono-plex text-[10.5px] tracking-[0.12em] text-[var(--gold)] sm:text-[12px] sm:tracking-[0.2em]" data-testid="progress-bar-step">{step}</p>
      </div>
      <div className="mt-3 h-2 w-full overflow-hidden rounded-full border border-[rgba(232,184,74,0.3)] bg-black/60" role="progressbar" aria-valuenow={percent} aria-valuemin={0} aria-valuemax={100} aria-label={step}>
        <div className="h-full rounded-full bg-[image:var(--metal-gold)] shadow-[0_0_12px_rgba(232,184,74,0.6)]" style={{ width: `${percent}%` }} data-testid="progress-bar-fill" />
      </div>
    </div>
  </div>
);
